import React, { useContext, useEffect, useState } from "react";
import { Stack } from "react-bootstrap";
import profile from "../assets/u_avatar.png";
import { LuPenSquare } from "react-icons/lu";
import docxImg from "../assets/docx.png";
import { useParams } from "react-router-dom";
import { getPaperStatuses, updatePaperStatus } from "../api/Api";
import CustomSkeleton from "../components/CustomSkeleton";
import ChangePaperStatus from "../components/modals/ChangePaperStatus";
import { PaperContext } from "../contexts/PaperContextProvider";
import styles from "./SupplementaryMaterials.module.css";
import { Drawer } from "@mui/material";
import TaskComments from "../components/TaskComments";
import { BiCommentDetail } from "react-icons/bi";
import { FaCaretDown, FaCaretRight } from "react-icons/fa";
import AddPaperVersion from "../components/modals/AddPaperVersion";
import CustomButton from "../components/CustomButton";
import { PiUploadSimpleBold } from "react-icons/pi";
import { useNavigate } from "react-router-dom";

// not in use
function SupplementaryMaterials() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const { paperId } = useParams();
  const [statusModal, setStatusModal] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [openComments, setOpenComments] = useState(false);
  const [openAddPaperVersion, setOpenAddPaperVersion] = useState(false); // related to paper version popup

  const openPaperVersionPopUp = () => setOpenAddPaperVersion(true); // open add paper version popup
  const closePaperVersionPopUp = () => setOpenAddPaperVersion(false); // close add paper version popup

  const toggleCommentSection = () => setOpenComments(!openComments);

  const commentSectionOptions = {
    id: paperId,
    title: "Comments",
  };
  const {
    data: paper,
    loading,
    error: paperError,
    refresh,
  } = useContext(PaperContext);

  useEffect(() => {
    getPaperStatuses()
      .then((response) => {
        if (response.status === 200) setStatusList(response.data);
        console.log(response.data);
      })
      .catch((error) => setError(error));
  }, []);

  const handleStatusIconClick = () => setStatusModal(true); // open status modal

  const changeStatus = (statusId) => {
    // change status of the paper
    updatePaperStatus(paperId, statusId)
      .then((response) => {
        if (response.status === 200) {
          refresh();
        }
      })
      .catch((error) => {
        setError(error);
      });
    setStatusModal(false);
  };

  if (error || paperError)
    return <div>Error: {error.message || paperError}</div>; // Render error message if any

  return (
    <div className="p-4 h-100">
      <div className="d-flex flex-column h-100">
        {/* paper title */}
        <h4 className="mb-3 text-break text-capitalize fw-bold">
          {loading ? (
            <CustomSkeleton width={200} />
          ) : (
            paper?.name || "Paper Title"
          )}
        </h4>

        {/* paper details section */}
        <div className="mx-0 primary-box p-4 rounded-3 flex-grow-1">
          <div className="d-flex justify-content-between align-items-center">
            {/* avatar */}
            <div className="d-flex">
              {loading ? (
                <CustomSkeleton width={50} height={50} circle={true} />
              ) : (
                <img src={profile} className={styles.avatar} alt="profile" />
              )}
              <span className="align-content-center p1 ms-3 text-capitalize">
                {loading ? <CustomSkeleton width={100} /> : paper?.author}
              </span>
            </div>
            <div className="d-flex gap-2">
              {/* comment button */}
              <CustomButton
                variant="gray-outline"
                className={`${styles.customButton} p4 px-3 flex-reverse`}
                icon={<BiCommentDetail size={22} />}
                onClick={toggleCommentSection}
              >
                Comments
              </CustomButton>

              {/*navigate to manuscript validator */}
              <CustomButton
                pre={<PiUploadSimpleBold sx={{ width: 24 }} />}
                onClick={() => navigate("/manuscript-validator")}
              >
                Upload to validate
              </CustomButton>
            </div>
          </div>

          {/* status */}
          <div className="d-flex my-3 gap-4">
            <Stack
              direction="horizontal"
              gap={3}
              style={{ backgroundColor: "#FFF1C2" }}
              className="py-1 px-3 d-inline-flex flex-row"
            >
              <div className="fw-bold">Status:</div>
              <div className="p4 text-capitalize ">
                {loading ? (
                  <CustomSkeleton width={100} />
                ) : (
                  paper?.status || "Status"
                )}
              </div>
              <LuPenSquare
                style={{ cursor: "pointer" }}
                onClick={handleStatusIconClick}
                size={18}
                strokeWidth={3}
              />
            </Stack>
          </div>

          <div className="mt-4 primary-box p-4 rounded-3">
            {/* <div className="d-flex justify-content-between">
              <p className="text-secondary">Latest Version</p>
              <FaUpload size={24} className={`text-color-cyan p-1 ${styles.paperUploadIcon}`} onClick={openPaperVersionPopUp} />
            </div> */}
            <CurrentPaperVersion loading={loading} paper={paper} />
            {/* {paper?.versions.length>0 && <p className="text-secondary mt-3">Previous Uploads</p>}
            <OldPaperList loading={loading} papers={paper?.versions} /> */}
          </div>
        </div>
      </div>

      {/* paper status changing popup */}
      <ChangePaperStatus
        list={statusList}
        show={statusModal}
        handleSave={changeStatus}
        handleClose={() => setStatusModal(false)}
        refreshPaper={refresh}
        paperId={paperId}
      />

      {/* paper comments drawer*/}
      <Drawer
        anchor="right"
        open={openComments}
        onClose={toggleCommentSection}
        classes={{ paper: styles.drawerContent }}
      >
        <TaskComments
          variant="paper"
          paperId={paperId}
          close={toggleCommentSection}
          options={commentSectionOptions}
        />
      </Drawer>

      {/* add paper version popup */}
      <AddPaperVersion
        show={openAddPaperVersion}
        handleClose={closePaperVersionPopUp}
        paperId={paperId}
        refresh={refresh}
      />
    </div>
  );
}

export default SupplementaryMaterials;

// this is the paper version component which is used in the right side of the page
// paper has name, size, status, file_id
const CurrentPaperVersion = ({ loading, paper }) => {
  if (loading) {
    return <CustomSkeleton count={2} height={30} />;
  }
  return (
    <Stack direction="horizontal" gap={3} className="my-4 my-lg-0">
      <img src={docxImg} alt="pdf" style={{ width: "60px" }} />
      <Stack>
        <h6 className="opacity-75 text-break">
          {paper?.name || "Paper Title"}
        </h6>
        <Stack direction="horizontal" gap={3} className="text-secondary">
          <div>{paper?.file_size || "Size"}</div>
          <div style={{ color: "lightgreen" }}>{paper?.status}</div>
          {paper?.file_id && !paper.auto_delete_file ? (
            <a
              href={`${process.env.REACT_APP_BACKEND_BASE_URL}/media/papers/${paper?.file_id}`}
              target="_blank"
              rel="noreferrer"
              className="text-color-cyan"
            >
              Download
            </a>
          ) : (
            <span
              className="text-muted text-decoration-none"
              style={{ cursor: "not-allowed" }}
              title="The paper is deleted"
            >
              Download
            </span>
          )}

        </Stack>
      </Stack>
    </Stack>
  );
};

// this is the old paper version component which is used in the right side of the page
const OldPaperList = ({ loading, papers }) => {
  if (loading) {
    return <CustomSkeleton count={4} height={40} />;
  }
  return (
    <div>
      {papers.map((paper) => (
        <OldPaperVersion key={paper.id} paper={paper} />
      ))}
    </div>
  );
};

// this is the old paper version component which is used in OldPaperList component
const OldPaperVersion = ({ paper }) => {
  console.log(paper);
  const [expanded, setExpanded] = useState(false);
  return (
    <div
      style={{ cursor: "pointer" }}
      className="d-flex flex-column py-1 my-lg-0 text-secondary fs-13 fw-semibold"
    >
      <div
        className="d-flex align-items-center gap-2"
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? <FaCaretDown size={16} /> : <FaCaretRight size={16} />}
        <p className="mb-0">{paper.file_name}</p>
      </div>
      {expanded && (
        <Stack direction="horizontal" gap={3} className="ms-4">
          <div>{paper.file_size || "-"}</div>
          {/* <div style={{ color: "lightgreen" }}>{paper.status || "-"}</div> */}
          <a
            href={`${process.env.REACT_APP_BACKEND_BASE_URL}/media/papers/${paper?.file_id}`}
            className="text-color-cyan"
          >
            Download
          </a>
        </Stack>
      )}
    </div>
  );
};
